import AmbassadorBadgeIcon from "@/icons/ambassador-badge";
import FounderBadgeIcon from "@/icons/founder-badge";
import VerifiedBadgeIcon from "@/icons/verified-badge";
import { cn } from "@/lib/utils";
import Image from "next/image";

type TProfilePictureProps = {
	profilePictureUrl?: string | null;
	alternateText?: string | null;
	isAmbassador?: boolean | null;
	isVerified?: boolean | null;
	isFounder?: boolean | null;
	className?: { container?: string; image?: string; badgeImage?: string };
};

const ProfilePicture = ({
	profilePictureUrl,
	alternateText,
	isAmbassador = false,
	isVerified = false,
	isFounder = false,
	className,
}: TProfilePictureProps) => {
	return (
		<div
			className={cn(
				"relative h-fit w-fit rounded-full",
				isFounder && isVerified
					? "bg-gradient-to-r from-yellow-200 via-yellow-600 to-yellow-400 p-1"
					: "border border-gray-200",
				className?.container
			)}
		>
			<div>
				{profilePictureUrl ? (
					<Image
						className={cn("aspect-square h-full w-full object-cover", className?.image)}
						src={profilePictureUrl}
						alt={alternateText || "User"}
						width={1080}
						height={1080}
					/>
				) : (
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						fill="currentColor"
						className={className?.image}
					>
						<path
							fillRule="evenodd"
							d="M18.685 19.097A9.723 9.723 0 0021.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 003.065 7.097A9.716 9.716 0 0012 21.75a9.716 9.716 0 006.685-2.653zm-12.54-1.285A7.486 7.486 0 0112 15a7.486 7.486 0 015.855 2.812A8.224 8.224 0 0112 20.25a8.224 8.224 0 01-5.855-2.438zM15.75 9a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
							clipRule="evenodd"
						/>
					</svg>
				)}

				{isAmbassador && isVerified ? (
					<AmbassadorBadgeIcon
						className={cn(
							"absolute -bottom-10 left-1/2 z-10 h-20 w-20 -translate-x-1/2",
							className?.badgeImage
						)}
					/>
				) : isFounder && isVerified ? (
					<FounderBadgeIcon
						className={cn(
							"absolute -bottom-12 left-1/2 z-10 h-24 w-24 -translate-x-1/2",
							className?.badgeImage
						)}
					/>
				) : isVerified ? (
					<VerifiedBadgeIcon
						className={cn(
							"absolute -bottom-8 left-1/2 z-10 h-20 w-20 -translate-x-1/2",
							className?.badgeImage
						)}
					/>
				) : null}
			</div>
		</div>
	);
};

export default ProfilePicture;
